import React from 'react';
import './App.css';
import InstallPWA from './InstallPWA';

function App() {
  const bodegas = [
    "Viña Varela Sarranz", "Los Pinos", "Cata Mayor", "Bodega Garzon", 
    "Familia Traversa y Agua Nativa", "Los Cerros de San Juan", "Gimenez Mendez", 
    "La Carolina", "Don Pascual", "Piccolo Banfi", "Bodega Rovere", "Vinos Roses"
  ];

  const gastronomicos = [
    "La Magnolia", "Sarubbi", "Alpi (queso de cabra)", "UTU Curso de Gastronomía",
    "Extrablatt", "Mercado Helvético", "Chacineria Los 2 Carlitos", "Panaderia San Francisco",
    "La Marcelina", "Son Delicias", "AUTEL (Fondeau)", "Premezcla Rosa (Celiacos) Solange Bobenrieth",
    "Cattivelli", "Grupo de los 30", "Industrias lácteas: El Piamontés, La Granja (Brassetti), Lacteos Don Santi, Lacteos Pippo´s, Mobari, Naturalac, Lover."
  ];

  return (
    <div className="App">
      <header className="header">
        <h1>19ª Cata de Vino Solidaria</h1>
        <h2>Club de Leones Colonia Suiza</h2>
      </header>

      <main>
        <section className="event-description">
          <img 
            src={process.env.PUBLIC_URL + '/cata.jpeg'} 
            alt="Cata Solidaria"
            className="event-image" 
          />
          <p className="event-text">
            La actividad, ya tradicional en la región, reunirá propuestas gastronómicas, 
            vitivinícolas y culturales con el objetivo de recaudar fondos destinados 
            a apoyar a quienes más lo necesitan.
          </p>
        </section>

        <section className="event-details">
          <p>El <strong>jueves 04 de setiembre</strong> celebramos nuestra 19ª Cata de Vino Solidaria con la presencia de más de 12 bodegas y 12 propuestas gastronómicas.</p>
          <p>Nos acompañará, una vez más, el grupo de Edgardo Nieves con su inconfundible jazz 🎶.</p>
          <p className="highlight">🍷 Vino & 🍽 Gastronomía</p>
          <p>Una combinación perfecta para disfrutar y ayudar 💛.</p>

          <div className="info-card">
            <p><strong>📍 Lugar:</strong> Hotel Nirvana</p>
            <p><strong>🕘 Hora:</strong> 20:00</p>
            <p><strong>🎟 Entrada:</strong> $1200</p>
          </div>
        </section>
        {/* Invitation Video Section */}
      <section className="section" id="invitation">
          <div className="container">
            <div className="section-title fade-in">
              <h3>Lanzamiento 19 Cata de Vinos. Hotel Nirvana. Agosto 2025</h3>
            </div>
            <div className="video-container fade-in">
              <div className="video-wrapper">
                <iframe
                  src="https://www.youtube.com/embed/Ds4DtPOQXdA"
                  title="Lanzamiento 19 Cata de Vinos"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                ></iframe>
              </div>
            </div>
          </div>
        </section>
        <section className="tickets">
          <h2>🎫 Entradas a la Venta</h2>
          <p>En <strong>Estudio 20/20</strong> (Calle Colón 1080)</p>
          <p>Con miembros del <strong>Club de Leones</strong> 🦁</p>
          <p>O llamando al <a href="tel:098269123" className="ticket-button">098 269 123</a></p>
        </section>
        <section className="participants">
          <h2>Participantes 2025</h2>
          <div className="participantsGrid">
            <div className="participant-list">
              <h3>BODEGAS</h3>
              <ul>
                {bodegas.map((bodega, index) => (
                  <li key={index}>{bodega}</li>
                ))}
              </ul>
            </div>
            <div className="participant-list">
              <h3>GASTRONÓMICOS</h3>
              <ul>
                {gastronomicos.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      </main>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Organiza</h3>
            <p>Club de Leones Colonia Suiza</p>
          </div>
          <div className="footer-section">
            <h3>Contacto</h3>
            <p>📞 098 269 123</p>
            <p>📍 Estudio 2020 (Calle Colón 1080)</p>
          </div>
          <div className="footer-section">
            <h3>Síguenos</h3>
            <div className="social-links">
              <a href="https://www.facebook.com/leonescoloniasuiza" target="_blank" rel="noopener noreferrer">Facebook</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Colabora difundiendo URUGUAY 30.</p>
        </div>
      </footer>
      <InstallPWA />
    </div>
  );
}

export default App;
